import i18n from '@/locales/i18n';
import { request } from '@koi-design/vix-tools';
import { message } from '@koi-design/uxd-ui';
import { handleSessionExpired } from '@libs/authSession';
// import axios from 'axios';
// import requestConfig from '@/config/requestConfig';
import dayjs from 'dayjs';
import { chunk } from 'lodash-es';
import { jsonrepair } from 'jsonrepair';
import { nanoid } from 'nanoid';

import audioIcon from '@/assetsCommon/icon/audio.png';
import folderIcon from '@/assetsCommon/icon/folder.png';
import htmlIcon from '@/assetsCommon/icon/html.png';
import imgIcon from '@/assetsCommon/icon/img.png';
import otherIcon from '@/assetsCommon/icon/other.png';
import pdfIcon from '@/assetsCommon/icon/pdf.png';
import txtIcon from '@/assetsCommon/icon/txt.png';
import wordIcon from '@/assetsCommon/icon/word.png';
import zipIcon from '@/assetsCommon/icon/zip.png';
import xlsxIcon from '@/assetsCommon/icon/xlsx.png';
import markdownIcon from '@/assetsCommon/icon/md.png';
import pptIcon from '@/assetsCommon/icon/ppt.png';

export const getQueryParams = id => {
  const urlParams = new URLSearchParams(window.location.search);
  const queryParams = {};
  for (const [key, value] of urlParams.entries()) {
    queryParams[key] = value;
  }
  return queryParams[id];
};
export const getOptionMap = options =>
  options.reduce(
    (total, item) => ({
      ...total,
      [item.value]: item.label
    }),
    {}
  );

/**
 * Request without automatic timestamp parameter (for GET requests)
 * Use axios directly to avoid vix-tools adding timestamp parameter
 */
// export const requestWithoutTimestamp = config => {
//   return axios({
//     ...config,
//     headers: {
//       ...requestConfig.API_REQUEST_HEADERS,
//       [requestConfig.TOKEN_KEY]: requestConfig.GET_TOKEN(),
//       ...config.headers
//     },
//     timeout: config.timeout || requestConfig.API_REQUEST_TIMEOUT
//   })
//     .then(response => {
//       // Handle response similar to vix-tools request
//       if (
//         response.data &&
//         response.data.code === requestConfig.API_SUCCESS_CODE
//       ) {
//         return response.data;
//       }
//       return response.data;
//     })
//     .catch(error => {
//       // Handle error similar to vix-tools request
//       if (error.response) {
//         const { status, data: errorData } = error.response;
//         if (
//           status === 401 ||
//           errorData?.code === requestConfig.API_EXPIRED_CODE
//         ) {
//           requestConfig.EXPIRED_METHOD(error.response);
//         } else {
//           requestConfig.API_RESPONSE_ERROR_METHOD(status);
//         }
//       }
//       throw error;
//     });
// };

export const packApi = (
  requestParams,
  responseType = 'boolean',
  showTip = true
) => {
  return new Promise((resolve, reject) => {
    // chat flow for ai-write
    const targetPaths = ['/api/api-chatflow/'];
    const isTargetPath = targetPaths.some(
      path => requestParams.url && requestParams.url.includes(path)
    );
    if (isTargetPath && (requestParams.data || requestParams.params)) {
      const chatflowType = getQueryParams('chatflowType');
      if (chatflowType) {
        requestParams.data && (requestParams.data.chatflow_type = chatflowType);
        requestParams.params &&
          (requestParams.params.chatflow_type = chatflowType);
      }
    }
    request({
      ...requestParams,
      catchAll: true
    })
      .then(res => {
        if (res.data.code === '000000') {
          if (responseType === 'boolean') {
            if (showTip) {
              message.success(res.data.message);
            }
            resolve(true);
          } else if (responseType === 'object') {
            if (showTip) {
              message.success(res.data.message);
            }
            resolve(res.data.data);
          } else {
            resolve(res.data.data);
          }
        } else if (res.data.code === '400001') {
          handleSessionExpired(res);
          resolve(false);
        } else {
          message.error(res.data.message);
          resolve(false);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const hasDialog = () => {
  const dialogArr1 = document.querySelectorAll('.uui-modal-mask');
  const dialogArr2 = document.querySelectorAll(
    '.uui-modal-mask[style*="display: none"]'
  );
  if (dialogArr1.length !== dialogArr2.length) {
    return true;
  }
  return false;
};
export const getHour = time => {
  const date = new Date(time);
  return date.getHours();
};
export const getDay = time => {
  const date = new Date(time);
  return date.getDate();
};
export const getMonth = time => {
  const date = new Date(time);
  return date.getMonth() + 1;
};
export const toPercent = num => {
  if (Number.isNaN(num)) {
    return '-';
  }
  const percentage = num * 100;
  const roundedPercentage = parseFloat(percentage.toFixed(2));
  // + %

  const result = `${roundedPercentage}%`;
  return result;
};
export const formatTimeToChatTime = time => {
  if (!time) {
    return '';
  }
  const now = dayjs();
  const target = dayjs(time);

  if (now.isSame(target, 'day')) {
    return target.format('HH:mm:ss');
  }
  return target.format('MM/DD HH:mm:ss');
};
export const referenceHasConetnt = reference => {
  return reference.text || reference.qa || reference.file.length;
};
export const isMobileDevice = () => {
  const userAgentInfo = navigator.userAgent;
  const mobileAgents = [
    'Android',
    'iPhone',
    'iPad',
    'iPod',
    'BlackBerry',
    'Windows Phone',
    'Opera Mini',
    'IEMobile'
  ];
  const deviceWidth = window.screen.width;
  const isMobile = deviceWidth < 768;
  return mobileAgents.some(agent => userAgentInfo.includes(agent)) || isMobile;
};
const HTML_ESCAPE_TEST_RE = /[&<>"]/;
const HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const HTML_REPLACEMENTS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
};
function replaceUnsafeChar(ch) {
  return HTML_REPLACEMENTS[ch];
}
export const escapeHtml = str => {
  if (HTML_ESCAPE_TEST_RE.test(str)) {
    return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
  }
  return str;
};
export const stripHtmlToPlainText = value => {
  if (value === null || value === undefined) {
    return '';
  }
  if (typeof value !== 'string') {
    return String(value).trim();
  }
  if (!/[<>]/.test(value)) {
    return value.trim();
  }
  if (typeof DOMParser === 'undefined') {
    return value
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(value, 'text/html');
  return (doc.body?.textContent || '').trim();
};
export const parseFileName = fullFileName => {
  if (!fullFileName) {
    return {
      fileName: '',
      extension: ''
    };
  }
  const splitResult = fullFileName.split('.');
  const extension = splitResult.pop();
  const fileNameWithoutExtension = splitResult.join('.');
  return {
    fileName: fileNameWithoutExtension,
    extension
  };
};
export const getFileTypeIcon = (fileType, name) => {
  const map = {
    1: 'textFile',
    2: 'qaFile',
    3: 'folder'
  };
  const icon = map[fileType];
  if (!icon) {
    const ext = parseFileName(name);
    const extension = ext.extension.toLowerCase();
    if (extension === 'docx') {
      return 'docx';
    }
    if (extension === 'doc') {
      return 'upload_doc';
    }
    if (extension === 'jpg') {
      return 'file_img';
    }
    if (extension === 'jpeg') {
      return 'file_img';
    }
    if (extension === 'png') {
      return 'file_img';
    }
    if (extension === 'excel') {
      return 'file-excel';
    }
    if (extension === 'xls') {
      return 'xlsx';
    }
    if (
      [
        'csv',
        'xls',
        'xlsx',
        'html',
        'md',
        'pdf',
        'pptx',
        'ppt',
        'gif',
        'txt',
        'mp3'
      ].includes(extension)
    ) {
      return extension;
    }
    return 'file_default';
  }
  return icon;
};
export const getIconByExtension = (extension = '') => {
  // Remove leading dot if present and convert to lowercase
  const ext = (
    extension.startsWith('.') ? extension.substring(1) : extension
  ).toLowerCase();
  if (ext === 'doc') {
    return 'upload_doc';
  }
  if (ext === 'docx') {
    return 'docx';
  }
  if (ext === 'jpg') {
    return 'file_img';
  }
  if (ext === 'jpeg') {
    return 'file_img';
  }
  if (ext === 'png') {
    return 'file_img';
  }
  if (ext === 'excel') {
    return 'file-excel';
  }
  return ext;
};
export const getFileTypeIconByFileName = (fileName = '') => {
  const fileType = fileName.split('.').pop().toLowerCase();
  if (fileType === 'pdf') {
    return 'pdf';
  }
  if (fileType === 'doc') {
    return 'upload_doc';
  }
  if (fileType === 'docx') {
    return 'docx';
  }
  if (fileType === 'txt') {
    return 'txt';
  }
  if (fileType === 'html') {
    return 'html';
  }
  if (fileType === 'ppt') {
    return 'ppt';
  }
  if (fileType === 'pptx') {
    return 'pptx';
  }
  if (fileType === 'md') {
    return 'md';
  }
  if (fileType === 'xls') {
    return 'xls';
  }
  if (fileType === 'xlsx') {
    return 'xlsx';
  }
  if (fileType === 'csv') {
    return 'csv';
  }
  if (fileType === 'png') {
    return 'file_img';
  }
  if (fileType === 'jpg') {
    return 'file_img';
  }
  if (fileType === 'jpeg') {
    return 'file_img';
  }
  if (fileType === 'zip') {
    return 'zip';
  }
  return 'file_default';
};
export const getFileNameFromContentDisposition = disposition => {
  let fileName = '';
  if (disposition.includes("filename*=utf-8''")) {
    const matches = disposition.match(/filename\*=utf-8''([^;]*)/);
    if (matches && matches[1]) {
      fileName = decodeURIComponent(matches[1]);
    }
  } else {
    const matches =
      disposition.match(/filename="([^"]*)"/) ||
      disposition.match(/filename=([^;]*)/);
    if (matches && matches[1]) {
      fileName = decodeURIComponent(matches[1]);
    }
  }
  return fileName;
};
export const countAndDeduplicateById = arr => {
  const countedObjects = {};
  arr.forEach(obj => {
    if (!countedObjects[obj.id]) {
      countedObjects[obj.id] = {
        ...obj,
        count: 0
      };
    }
    countedObjects[obj.id].count += 1;
  });
  return Object.values(countedObjects);
};
export const getRandomFiveOrReturnArray = arr => {
  if (!arr) {
    return [];
  }
  return chunk(arr, 5);
};
export const generateMessageChat = (botInfo, id, welcome_message) => {
  const rawList = botInfo.top_question_list;
  const listForTopQuestion =
    botInfo.is_i18n && botInfo.fixed_language && Array.isArray(rawList)
      ? rawList.filter(item => item.language === botInfo.fixed_language)
      : rawList;

  return {
    type: 'json',
    id,
    answer_type: 'json',
    answer: {
      description: welcome_message ?? botInfo.welcome_message,
      type: 'welcome_message',
      data: {
        top_question_list: getRandomFiveOrReturnArray(listForTopQuestion),
        is_top_question: botInfo.is_top_question
      }
    }
  };
};
export const findLabelByValue = (data, value) => {
  return data.find(item => `${item.value}` === `${value}`)?.label || null;
};
export const transformTree = tree => {
  return tree.map(node => {
    const transformedNode = {
      title: node.name,
      value: node.id,
      key: node.id,
      children: node.children ? transformTree(node.children) : []
    };
    return transformedNode;
  });
};
export const getRecentSevenDays = () => {
  const now = dayjs();
  const sevenDaysAgo = now.subtract(7, 'day');
  return [sevenDaysAgo.format('YYYY-MM-DD'), now.format('YYYY-MM-DD')];
};

export const getRecentDays = days => {
  const now = dayjs();
  const daysAgo = now.subtract(days, 'day');
  return [
    daysAgo.format('YYYY-MM-DD HH:mm:ss'),
    now.format('YYYY-MM-DD HH:mm:ss')
  ];
};

export const getTodayRange = () => {
  const now = dayjs();
  const todayStart = now.startOf('day');
  return [
    todayStart.format('YYYY-MM-DD HH:mm:ss'),
    now.format('YYYY-MM-DD HH:mm:ss')
  ];
};

export function convertBrAndDivToNewline(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  let text = '';
  function traverseNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      text += node.textContent;
    } else if (node.tagName.toLowerCase() === 'div') {
      text += `${node.textContent.trim()}\n`;
    } else if (node.tagName.toLowerCase() === 'br') {
      text += '\n';
    } else {
      for (let i = 0; i < node.childNodes.length; i++) {
        traverseNode(node.childNodes[i]);
      }
    }
  }
  if (doc.body) {
    traverseNode(doc.body);
  }
  return text.trim();
}
export const getOrigin = () => {
  const origin =
    import.meta.env.MODE === 'development'
      ? 'https://192.168.160.58'
      : window.location.origin;
  return origin;
};
export const findNodeById = (tree, id) => {
  // Base case: empty tree
  if (!tree || tree.length === 0) return null;

  // Search through each node at current level
  for (const node of tree) {
    // Check if current node matches id
    if (node.node_uuid === id) {
      return node;
    }

    // Recursively search children if they exist
    if (node.sub_headings && node.sub_headings.length > 0) {
      const found = findNodeById(node.sub_headings, id);
      if (found) return found;
    }
  }
  return null;
};
export const findNodeParentById = (tree, id, parent = null) => {
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.node_uuid === id) {
      return parent;
    }
    if (node.sub_headings && node.sub_headings.length > 0) {
      const result = findNodeParentById(node.sub_headings, id, node);
      if (result) {
        return result;
      }
    }
  }
  return null;
};
export const changeTreeStatus = (tree, id, key, value) => {
  // Base case: empty tree
  if (!tree || tree.length === 0) return null;

  // Search through each node at current level
  for (const node of tree) {
    // Check if current node matches id
    if (node.node_uuid === id) {
      node[key] = value;
    } else {
      node[key] = !value;
    }

    // Recursively search children if they exist
    if (node.sub_headings && node.sub_headings.length > 0) {
      changeTreeStatus(node.sub_headings, id, key, value);
    }
  }
  return null;
};

// Find the path from root to a specific node
export const findNodePath = (tree, targetId, currentPath = []) => {
  if (!tree || tree.length === 0) return null;
  for (const node of tree) {
    const newPath = [...currentPath, node.node_uuid];
    if (node.node_uuid === targetId) {
      return newPath;
    }
    if (node.sub_headings && node.sub_headings.length > 0) {
      const foundPath = findNodePath(node.sub_headings, targetId, newPath);
      if (foundPath) {
        return foundPath;
      }
    }
  }
  return null;
};

// Expand only the parent nodes in the path to the target node
export const expandNodePath = (tree, targetId) => {
  const path = findNodePath(tree, targetId);
  if (!path) return;

  // Expand nodes in the path (excluding the target node itself)
  const expandPath = (nodes, pathIndex = 0) => {
    if (pathIndex >= path.length - 1) return; // Don't expand the target node itself

    for (const node of nodes) {
      if (node.node_uuid === path[pathIndex]) {
        node.isExpanded = true;
        if (node.sub_headings && node.sub_headings.length > 0) {
          expandPath(node.sub_headings, pathIndex + 1);
        }
        break;
      }
    }
  };
  expandPath(tree);
};
export const countNodes = tree => {
  if (!Array.isArray(tree)) return 0;
  return tree.reduce((total, node) => {
    let count = 1;
    if (node.sub_headings && node.sub_headings.length > 0) {
      count += countNodes(node.sub_headings);
    }
    return total + count;
  }, 0);
};
export const formatFileSize = size => {
  if (!size) {
    return '-';
  }
  const sizeInMB = size / 1024 / 1024;
  if (sizeInMB < 0.01) {
    return `${(size / 1024).toFixed(2)}K`;
  }
  return `${sizeInMB.toFixed(2)}M`;
};
export const truncateMiddle = (str, maxLength = 20, separator = '...') => {
  if (!str || typeof str !== 'string') return '';
  if (str.length <= maxLength) return str;
  const separatorLength = separator.length;
  const charsToShow = maxLength - separatorLength;
  const frontChars = Math.ceil(charsToShow / 2);
  const backChars = Math.floor(charsToShow / 2);
  return (
    str.substr(0, frontChars) + separator + str.substr(str.length - backChars)
  );
};
export function sleep(ms) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}
export const splitCodeBlocks = inputString => {
  if (!inputString) return [];
  let processedString = inputString;
  const codeBlockMarkers = (processedString.match(/```/g) || []).length;
  if (codeBlockMarkers === 0) {
    return [
      {
        type: 'text',
        content: inputString.trim()
      }
    ];
  }
  if (codeBlockMarkers % 2 === 1) {
    if (processedString.endsWith('``')) {
      processedString += '`';
    } else if (processedString.endsWith('`')) {
      processedString += '``';
    } else {
      processedString += '```';
    }
  }
  const parts = processedString.split('```').filter(i => i !== '');
  const result = parts.map(part => {
    const trimmedPart = part.trim();
    const specialTypes = [
      'mermaid',
      'location_address_json',
      'cybothtml',
      'agenthtml',
      'echarts',
      'shareholding'
    ];
    const specialFormatMatch = trimmedPart.match(/^(\w+)\s+'([^']+)'\s*$/);
    if (specialFormatMatch) {
      const [, typeName, content] = specialFormatMatch;
      return {
        type: typeName,
        content
      };
    }
    const startWithSpecialType = specialTypes.find(type =>
      trimmedPart.startsWith(type)
    );
    if (startWithSpecialType) {
      const codeContent = trimmedPart
        .slice(startWithSpecialType.length)
        .replace(/^\r?\n/, '')
        .trim();
      return {
        type: startWithSpecialType,
        content: codeContent
      };
    }
    const lines = trimmedPart.split('\n');
    const firstLine = lines[0].trim();
    if (firstLine && firstLine.match(/^[a-zA-Z_]+$/)) {
      return {
        type: 'text',
        content: `\`\`\`${firstLine}\n${lines.slice(1).join('\n').trim()}`
      };
    }
    return {
      type: 'text',
      content: trimmedPart
    };
  });
  return result;
};
export const jsonParse = json => {
  let result = null;
  try {
    result = jsonrepair(json);
    result = JSON.parse(result);
  } catch (e) {
    // // eslint-disable-next-line no-new-func
    // const parseObject = new Function(`return ${json}`);
    // console.log(parseObject(), 889);
    return null;
  }
  return result;
};
export const getFileIcon = fileNameString => {
  if (!fileNameString) {
    return otherIcon;
  }
  const fileName = String(fileNameString).trim().toLowerCase();
  const extension = fileName.split('.').pop();
  switch (extension) {
    case 'png':
    case 'gif':
    case 'webp':
    case 'jpeg':
    case 'jpg':
      return imgIcon;
    case 'pdf':
      return pdfIcon;
    case 'doc':
    case 'docx':
      return wordIcon;
    case 'xls':
    case 'xlsx':
    case 'csv':
      return xlsxIcon;
    case 'ppt':
    case 'pptx':
      return pptIcon;
    case 'txt':
      return txtIcon;
    case 'md':
    case 'markdown':
      return markdownIcon;
    case 'html':
    case 'htm':
      return htmlIcon;
    case 'wav':
    case 'mp3':
    case 'pcm':
    case 'silk':
    case 'm4a':
    case 'aac':
    case 'amr':
      return audioIcon;
    case 'zip':
    case '7z':
    case 'tar':
    case 'gz':
    case 'tgz':
    case 'bz2':
    case 'tbz2':
    case 'xz':
    case 'txz':
      return zipIcon;
    default:
      return otherIcon;
  }
};

export { folderIcon };

export const deleteItemById = (treeData, targetId) => {
  if (!Array.isArray(treeData)) {
    return false;
  }
  for (let i = 0; i < treeData.length; i++) {
    if (treeData[i].id === targetId) {
      treeData.splice(i, 1);
      return true;
    }
  }
  for (const item of treeData) {
    if (item.children && Array.isArray(item.children)) {
      if (deleteItemById(item.children, targetId)) {
        return true;
      }
    }
  }
  return false;
};
// Convert input_parameters_config object to array
export const convertObjectToArray = inputParamsConfig => {
  if (!inputParamsConfig || typeof inputParamsConfig !== 'object') {
    return [];
  }
  return Object.keys(inputParamsConfig).map(key => ({
    name: key,
    pass_value: inputParamsConfig[key].pass_value || '',
    pass_method: inputParamsConfig[key].pass_method || 'llm',
    llm_visible: inputParamsConfig[key].llm_visible || false
  }));
};

// Convert input_parameters_config array to object
export const convertArrayToObject = inputParamsArray => {
  if (!Array.isArray(inputParamsArray) || inputParamsArray.length === 0) {
    return {};
  }
  return inputParamsArray.reduce((obj, item) => {
    if (item.name) {
      obj[item.name] = {
        pass_value: item.pass_value || '',
        pass_method: item.pass_method || 'llm'
      };
    }
    return obj;
  }, {});
};
export const isWeixinBrowser = () => {
  return /MicroMessenger/i.test(navigator.userAgent);
};

export const paramsArrayToSchema = (paramsArray, options = {}) => {
  const {
    descField = 'description',
    requiredField = 'required',
    orderField = ''
  } = options;
  if (!Array.isArray(paramsArray) || paramsArray.length === 0) {
    return {
      type: 'object',
      properties: {},
      required: []
    };
  }
  const schema = {
    type: 'object',
    properties: {},
    required: []
  };
  const propertyOrder = [];
  paramsArray.forEach(param => {
    if (!param.name) return;
    const propSchema = {
      type: param.type || 'string'
    };

    const descValue = param[descField] || param.description || param.desc || '';
    if (descValue) {
      propSchema.description = descValue;
    }

    const excludedFields = [
      'name',
      'type',
      descField,
      'description',
      'desc',
      requiredField,
      'id'
    ];
    Object.keys(param).forEach(key => {
      if (!excludedFields.includes(key)) {
        propSchema[key] = param[key];
      }
    });
    schema.properties[param.name] = propSchema;
    propertyOrder.push(param.name);

    const isRequired =
      param[requiredField] === 1 || param[requiredField] === true;
    if (isRequired) {
      schema.required.push(param.name);
    }
  });

  if (schema.required.length === 0) {
    delete schema.required;
  }
  if (orderField && propertyOrder.length > 0) {
    schema[orderField] = propertyOrder;
  }
  return schema;
};

export const schemaToParamsArray = (schema, options = {}) => {
  const {
    descField = 'description',
    requiredField = 'required',
    generateId = null,
    orderField = ''
  } = options;
  if (!schema || !schema.properties) {
    return [];
  }
  const idGenerator = generateId || (() => nanoid());
  const paramsArray = [];
  const orderedNames = [];
  const pushedNames = new Set();
  const rawOrder = orderField ? schema[orderField] : null;
  if (Array.isArray(rawOrder)) {
    rawOrder.forEach(name => {
      if (
        typeof name === 'string' &&
        Object.prototype.hasOwnProperty.call(schema.properties, name) &&
        !pushedNames.has(name)
      ) {
        orderedNames.push(name);
        pushedNames.add(name);
      }
    });
  }
  Object.keys(schema.properties).forEach(name => {
    if (!pushedNames.has(name)) {
      orderedNames.push(name);
      pushedNames.add(name);
    }
  });
  orderedNames.forEach(name => {
    const propSchema = schema.properties[name];
    const param = {
      id: idGenerator(),
      name,
      type: propSchema.type || 'string'
    };

    if (propSchema.description) {
      param[descField] = propSchema.description;
    }

    param[requiredField] = schema.required?.includes(name) ? 1 : 0;

    const standardFields = ['type', 'description', 'required', requiredField];
    Object.keys(propSchema).forEach(key => {
      if (!standardFields.includes(key)) {
        param[key] = propSchema[key];
      }
    });
    paramsArray.push(param);
  });
  return paramsArray;
};

export const schemaToArr = schema => {
  if (Object.keys(schema).length === 0) {
    return [];
  }
  const parseSubSchema = (subSchema, parentKey = '') => {
    const field = {
      name: parentKey,
      key: parentKey,
      type: subSchema.type || 'object',
      required: false,
      properties: {},
      children: []
    };

    const schemaKeywords = [
      'type',
      'properties',
      'items',
      'required',
      'minItems',
      'maxItems',
      'uniqueItems'
    ];
    Object.entries(subSchema).forEach(([key, value]) => {
      if (!schemaKeywords.includes(key)) {
        field.properties[key] = value;
      }
    });

    if (subSchema.type === 'object' && subSchema.properties) {
      Object.entries(subSchema.properties).forEach(([key, propSchema]) => {
        const isRequired = !!subSchema.required?.includes(key);
        const childField = parseSubSchema(propSchema, key);
        childField.required = isRequired;
        field.children.push(childField);
      });
    }

    if (subSchema.type === 'array' && subSchema.items) {
      if (subSchema.minItems !== undefined)
        field.properties.minItems = subSchema.minItems;
      if (subSchema.maxItems !== undefined)
        field.properties.maxItems = subSchema.maxItems;
      if (subSchema.uniqueItems !== undefined)
        field.properties.uniqueItems = subSchema.uniqueItems;

      if (subSchema.items.type === 'object' && subSchema.items.properties) {
        Object.entries(subSchema.items.properties).forEach(
          ([key, propSchema]) => {
            const isRequired = !!subSchema.items.required?.includes(key);
            const childField = parseSubSchema(propSchema, key);
            childField.required = isRequired;
            field.children.push(childField);
          }
        );
      } else {
        const itemField = parseSubSchema(subSchema.items, 'item');
        itemField.required = true;
        field.children.push(itemField);
      }
    }
    return field;
  };

  if (schema.type === 'object') {
    return parseSubSchema(schema).children;
  }
  // For array and basic types (string, number, integer, boolean, etc.), root nodes
  // have no named properties. Use __root__ as a unified placeholder name.
  const rootField = parseSubSchema(schema, '__root__');
  return [rootField];
};

export const arrToSchema = (arr, rootType = 'object') => {
  const buildSubSchema = field => {
    const subSchema = {
      type: field.type || 'object',
      ...field.properties
    };

    if (field.type === 'object' && field.children.length > 0) {
      subSchema.properties = {};
      subSchema.required = [];
      field.children.forEach(child => {
        subSchema.properties[child.key] = buildSubSchema(child);
        if (child.required) {
          subSchema.required.push(child.key);
        }
      });
      if (subSchema.required.length === 0) delete subSchema.required;
    }

    if (field.type === 'array' && field.children.length > 0) {
      subSchema.items = buildSubSchema(field.children[0]);
      delete subSchema.items.key;
    }
    return subSchema;
  };

  if (rootType === 'object') {
    const rootSchema = {
      type: 'object',
      properties: {},
      required: []
    };
    arr.forEach(field => {
      rootSchema.properties[field.key] = buildSubSchema(field);
      if (field.required) {
        rootSchema.required.push(field.key);
      }
    });
    if (rootSchema.required.length === 0) delete rootSchema.required;
    return rootSchema;
  }
  // For array and basic types (string, number, integer, boolean, etc.), root nodes are all carried by __root__
  if (arr.length !== 1 || arr[0].key !== '__root__') {
    throw new Error(
      i18n.global.t('libs.tools.8bda4fd05263024e06d025e9618103f2')
    );
  }
  return buildSubSchema(arr[0]);
};
export const isAndroidOrHarmonyBrowser = () => {
  return /Android|HarmonyOS/i.test(navigator.userAgent);
};
export const formatDraftSavedAt = value => {
  const now = dayjs();
  const time = dayjs(value);
  if (now.isSame(time, 'day')) {
    return time.format('HH:mm');
  }
  return time.format('MM-DD HH:mm');
};

/**
 * Extract children from an array of objects and flatten into a one-dimensional array
 * @param {Array} arr - Array of objects with children property
 * @param {string} childrenKey - The key name for children (default: 'children')
 * @returns {Array} Flattened one-dimensional array of all children
 */
export const flattenChildren = (arr, childrenKey = 'children') => {
  if (!Array.isArray(arr) || arr.length === 0) {
    return [];
  }
  return arr.reduce((result, item) => {
    if (item[childrenKey]) {
      return [...result, ...item[childrenKey]];
    }
    return result;
  }, []);
};

/**
 * Format number with comma separator every 3 digits
 * @param {number|string} num - Number to format
 * @returns {string} Formatted number string with commas
 * @example
 * formatNumberWithComma(1000) // '1,000'
 * formatNumberWithComma(1000000) // '1,000,000'
 * formatNumberWithComma(123456789) // '123,456,789'
 */
export const formatNumberWithComma = num => {
  if (num === null || num === undefined || num === '') {
    return '';
  }
  // Convert to string and handle decimal numbers
  const numStr = String(num);
  // Split integer and decimal parts
  const parts = numStr.split('.');
  // Format integer part with commas
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // Join integer and decimal parts
  return parts.join('.');
};
export const generateRange = (start, end) => {
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};
